"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatCell = exports.defaultOptions = exports.CellRenders = void 0;

var _accounting = _interopRequireDefault(require("accounting"));

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var CellRenders = {
  CURRENCY: "currency",
  DATE: "date",
  DATETIME: "datetime",
  NUMBER: "number",
  STRING: "string"
};
exports.CellRenders = CellRenders;
var defaultOptions = {
  currency: {
    symbol: "$",
    symbolAlign: "left"
  },
  date: {
    format: "MMM DD, YYYY"
  },
  datetime: {
    format: "MMM DD, YYYY HH:mm"
  },
  emptyCellValue: "-",
  hasStickyHeader: true,
  tableContainerProps: {},
  timezone: _momentTimezone.default.tz.guess()
};
exports.defaultOptions = defaultOptions;

var formatCell = function formatCell(column, row, options) {
  var cell = row[column.id];
  var render = column.render;
  if (cell === undefined || cell === null) return options.emptyCellValue;

  switch (render) {
    case CellRenders.STRING:
      return cell;

    case CellRenders.NUMBER:
      return _accounting.default.formatNumber(cell);

    case CellRenders.CURRENCY:
      {
        var symbol = cell.symbol === undefined ? options.currency.symbol : cell.symbol;
        var value = cell.value === undefined ? cell : cell.value;
        var format = options.currency.symbolAlign === "right" ? "%v%s" : "%s%v";
        return _accounting.default.formatMoney(value, {
          format: format,
          symbol: symbol
        });
      }

    case CellRenders.DATE:
    case CellRenders.DATETIME:
      return (0, _momentTimezone.default)(cell).tz(options.timezone).format(options[render].format);

    default:
      return options.emptyCellValue;
  }
};

exports.formatCell = formatCell;